export default "/assets/seismic_learning_logo-91b68cf84d061cdda6fc3ac7aa3f5528817c521412fb6c336200586337357965.png";